import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  hideCustomReportModalForDelete,
} from './store/actions';

import {
  isDeletingCustomReportSelector,
} from './store/selectors';

import Modal from '../../shared/modals/modal.component';
import { requiredWhenPresent } from '../../shared/propTypes';

class DeleteCustomReportModal extends PureComponent {
  static propTypes = {
    hideModal: PropTypes.func.isRequired,
    removeEntity: PropTypes.func.isRequired,
    entityToRemove: requiredWhenPresent(['isVisible'], PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })),
    isDeletingInProgress: PropTypes.bool,
    isVisible: PropTypes.bool,
  };

  deleteCustomReport = () => {
    const {
      removeEntity,
      entityToRemove,
    } = this.props;

    removeEntity(entityToRemove);
  };

  render() {
    const {
      hideModal,
      entityToRemove,
      isDeletingInProgress,
      isVisible,
    } = this.props;

    return (
      <Modal
        className="delete-custom-report-modal"
        title="Delete Custom Report"
        closeAction={hideModal}
        dismissText="Cancel"
        dismissAction={hideModal}
        submitText="Yes"
        submitAction={this.deleteCustomReport}
        isSubmitting={isDeletingInProgress}
        isVisible={isVisible}
      >
        {
          entityToRemove
            ? (
              <div>
                Are you sure you want to delete this custom report? <br/>
                Your action will generate a run-time error if the query is being called within TLS. <br/><br/>
                Custom Report ID: {entityToRemove.id}<br/>
                Custom Report Name: {entityToRemove.name}<br/><br/>
              </div>
            )
            : null
        }
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isDeletingInProgress: isDeletingCustomReportSelector(state),
});

export default connect(
  mapStateToProps,
  {
    hideModal: hideCustomReportModalForDelete,
  }
)(DeleteCustomReportModal);
